// extracted by mini-css-extract-plugin
export default {"root":"_efDPV","icon-wrapper":"vDK9v4","iconWrapper":"vDK9v4","discount-text":"ngpTrf","discountText":"ngpTrf","sale":"wfJqmA"};